/* eslint-disable jsx-a11y/no-access-key */
import React, { useEffect, useState } from 'react'
import style from './style.module.sass'
import folderUploadIcon from '../assets/Icon-metro-folder-download.svg'
import folderUploadIconLight from '../assets/Icon-metro-folder-download-light.svg'
import folderUploadIconDark from '../assets/Icon-metro-folder-download-dark.svg'
import txtIcon from '../../../assets/txt-icon.png'
import docIcon from '../../../assets/doc-icon.png'
import docxIcon from '../../../assets/docx-icon.png'
import htmlIcon from '../../../assets/html-icon.png'

import { Add, Check, Equalizer, Replay, ViewDay, Remove, Delete, DataUsage } from '@material-ui/icons'
import autoFixHigh from '../../../assets/auto-fix-high.svg'
import autoFixHighLight from '../../../assets/auto-fix-high-light.svg'
import autoFixHighDark from '../../../assets/auto-fix-high-dark.svg'
import { useTheme } from '@material-ui/core/styles'
import { Button, Collapse } from '@material-ui/core'
import ErrorModal from '../Overview/ErrorModal'
import ComponentWithPop from '../../common/ComponentWithPop'
import { NavLink } from 'react-router-dom'
import WordExportModal from './WordExportModal'
import AssignmentIcon from '@material-ui/icons/Assignment'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import WordSaveInArchive from './WordSaveInArchive'
import ExportIssueDetails from './ExportIssueDetails'
import { useTranslation } from 'react-i18next'
import Dropzone from 'react-dropzone'
import WordSaveNewVersion from './WordSaveNewVersion'
import { checkAiText, generateBList, isObjectEmpty } from '../../../utils'
import { useSelector } from 'react-redux'
import {
  analyseSetBodyBorderShow,
  allowlistText,
} from '../../../actions'
import ErrorPopup from '../ModalWindows/ErrorModal'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import SaveIcon from '@material-ui/icons/Save'
import { useActions } from '../../../utils/action-helper'
import ComBotWhiteNoHorn from '../../../assets/combot-white-no-horn.svg'
import ComBotGreyNoHorn from '../../../assets/combot-grey-no-horn.svg'
import ComBotBlackNoHorn from '../../../assets/combot-black-no-horn.svg'

import LightningModal from '../ModalWindows/LightningModal'
import BaseModal from '../../ModalWindows/BaseModal'
import config from '../../../config'

function CircularProgressWithLabel (props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate"
                        size="2rem"
                        {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary" style={{ fontSize: '10px' }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}

function HeadPart ({
  handleShowBorders,
  editor,
  handleDownloadAsFile,
  handleRestartAll,
  mustReload,
  setMustReload,
  handleOnAnalyseClick,
  handleAnalyseFromAi,
  handleBatchProcessingUpload,
  selectedText,
  handleStopRVAnalyse,
  showUploadBar,
  uploadBarNow,
  checkKeys,
  showLoadText,
  setShowLoadText, closePopupWindow
}) {

  const { t } = useTranslation()

  const resultTemplate = useSelector(state => state.analyseData.result.resultTemplate)
  const bodyBorderShow = useSelector(state => state.analyseData.bodyBorderShow)
  // get user reducers
  const enabledSections = useSelector(state => state.userData.user?.enabled_frontend_sections || [])
  const customOptions = useSelector(state => state.userData.user?.custom_options || {})
  //const pathname = window.location.pathname;
  // const [openAddAllowedL, setOpenAddAllowedL] = useState(false);
  // const [openToBin, setOpenToBin] = useState(false);
  // const [wordExportOpen, setWordExportOpen] = useState(false);
  // const [wordSaveOpen, setWordSaveOpen] = useState(false);
  // const [wordSaveAsArchiveOpen, setWordSaveAsArchive] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false)
  const [modalOpenType, setModalOpenType] = useState(undefined)
  const [modalState, setModalState] = useState(true)
  const [baseModalType, setBaseModalType] = useState(undefined)

  const [magicWandEnable, setMagicWandEnable] = useState(false)

  //const archives = useSelector(state => state.analyseData.archives);
  const saveArchive = useSelector(state => state.analyseData.saveArchive)
  const allowListText = useSelector(state => state.analyseData.allowListText)
  const analyseResult = useSelector(state => state.analyseData.result.resultData)
  const allowedListsData = useSelector(state => state.userData.allowedLists)
  const textToneData = useSelector(state => state.userData.textTone) || []
  //const enableTextBin = useSelector(state => state.userData.user.user_options?.enable_textbin);
  //const userTypeId = useSelector(state => state.userData.user.user_type_id);
  const enabledTemplate = useSelector(state => state.userData.user.enabled_templates)
  const fileName = useSelector(state => state.analyseData.fileName)
  const text = useSelector((state) => state.analyseData.text)

  const useBenchmark = useSelector(state => state.analyseData.useBenchmark)
  const aiMaxTextSize = useSelector((state) => state.userData.user.ai_settings?.max_text_size || {})
  const theme = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const benchmarks = useSelector(state => state.userData.benchmarks)
  const taskTypes = useSelector(state => state.userData.taskTypes || [])
  const isContrast = theme !== config.THEMES_MODES.LIGHT

  const { theme: { bgColors, borderColors, colors } } = useTheme()
  //const success = useSelector(state => state.textEditor.success)
  //const success = true;
  const textIsSelected = { text: null, type: null }
  const onTextSelect = () => true
  const [error, setError] = useState(null)

  const { actionAnalyseSetBodyBorderShow, actionAllowlistText } = useActions({
    actionAnalyseSetBodyBorderShow: analyseSetBodyBorderShow,
    actionAllowlistText: allowlistText
  })

  const aiButtonEnable = checkAiText(text, aiMaxTextSize, 'Assistant')

  useEffect(() => {

    const filteredTaskTypes = taskTypes.filter(el => el?.function === 'MagicWand')
    if (isObjectEmpty(filteredTaskTypes) || isObjectEmpty(benchmarks)) {
      setMagicWandEnable(false)
      return
    }

    const [selectedBList, ] = generateBList(filteredTaskTypes, benchmarks, useBenchmark, 'magicWandPrompt')

    if (selectedBList === -1) {
      setMagicWandEnable(false)
      return
    }
    setMagicWandEnable(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benchmarks, taskTypes, useBenchmark])

  const accessKeys = config.accessKeys
  const magicWantIcon = isContrast ? (theme === config.THEMES_MODES.CONTRAST_DARK ? autoFixHighDark : autoFixHighLight) : autoFixHigh
  const folderIcon = isContrast ? (theme === config.THEMES_MODES.CONTRAST_DARK ? folderUploadIconDark : folderUploadIconLight) : folderUploadIcon

  // If User Clicks on the Erlaubt(Allowed) btn from accordion, it opens up the modal for AllowList //
  useEffect(() => {
    if (allowListText?.length) {
      setBaseModalType(prev => prev === 'AddTextTone' ? 'AddTextTone' : 'AddAllowedList')
    }
  }, [allowListText])

  // To Show Border text if dataBodyRecognition exist:
  useEffect(() => {
    setTimeout(() => {
      if (analyseResult?.dataBodyRecognition && (analyseResult.dataBodyRecognition[0] > -1 || analyseResult.dataBodyRecognition[1] > -1)) {
        actionAnalyseSetBodyBorderShow(true)
        handleShowBorders(true)
      }
    }, [1000])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  let modalResult

  switch (modalOpenType) {
    case 'WordExportModal':
      modalResult = <WordExportModal setOpen={setModalOpenType} title={'Word export'}/>
      break
    case 'WordSaveModal':
      modalResult = <WordExportModal setOpen={setModalOpenType}/>
      break
    case 'WordSaveAsNewVersion':
      modalResult = <WordSaveNewVersion setOpen={setModalOpenType} modalState={modalState}
                                        setModalState={setModalState}/>
      break
    case 'WordSaveInArchive':
      modalResult = <WordSaveInArchive setOpen={setModalOpenType} modalState={modalState}
                                       setModalState={setModalState} nextTabsAction={() => {
        // setWordSaveAsArchive(false);
        // setWordExportOpen(true)
      }}/>
      break
    case 'exportIssueDetails':
      modalResult = <ExportIssueDetails setOpen={setModalOpenType} modalState={modalState}
                                        setModalState={setModalState} text={t('Export issue details')}/>
      break
    case 'LightningModal':
      if (selectedText !== undefined) {
        modalResult = <LightningModal setOpen={setModalOpenType} open={true} selectedText={selectedText} editor={editor}
                                      handleAnalyseFromAi={handleAnalyseFromAi}/>
      }
      break
    default:
      modalResult = null
  }

  const handleColBasinClick = (type) => {
    if (selectedText !== undefined) {
      if (mustReload) {
        handleOnAnalyseClick()
      }
      onTextSelect(type)
      actionAllowlistText(selectedText.getContent()
        .replaceAll(/<br[^>]*>|<p[^/>]*>|<h\d[^/>]*>/g, ' ')
        .replaceAll(/<\/?[^>]+>/g, '').trim())
      setBaseModalType(type === 'add' ? 'AddAllowedList' : 'AddTextTone')
      closePopupWindow()
    } else {
      setError({ text: t('select-some-text'), header: t('select-some-text') })
    }
  }

  const handleMagicWandClick = () => {
    if (selectedText !== undefined) {
      onTextSelect('ai')
      setModalOpenType('LightningModal')
      setModalState(true)
      closePopupWindow()
    } else {
      setError({ text: t('select-some-text'), header: t('select-some-text') })
    }
  }

  const handleAiNavClick = (event) => {
    if (!aiButtonEnable) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  return (
    <div className={`${style.headPart} d-flex justify-content-between align-items-center pl-2 pr-2`}>
      <ErrorModal setState={onTextSelect} state={textIsSelected}/>
      <ErrorPopup error={error} setError={setError}/>
      {/* modalResult display a modal that are triggered by the user   */}
      {modalResult}
      {baseModalType && <BaseModal
        setBaseModalType={setBaseModalType} baseModalType={baseModalType} selectedText={selectedText}
        editor={editor} headerText={baseModalType === 'AddAllowedList' ? 'add-allowedList' : 'add-textbin'}/>}
      <span className={style.text} style={{ color: colors.colorText }}>
             {fileName}
             </span>
      <div style={{ color: colors.colorPrimary400 }} className={`d-flex position-relative`}>
      </div>
      <div className={`d-flex align-items-center`} style={{ height: '100%' }} accessKey={accessKeys.editorMenu}
           tabIndex={config.tabIndexes.editorMenuBox}>
        {(resultTemplate > 0) &&
          <>
            <hr style={{ borderColor: borderColors.borderPrimary200 }}
                className={`m-0 ${style.hr} ${style.hidOnSmallScreen}  mr-2 ml-2`}/>
            {analyseResult?.dataBodyRecognition && (analyseResult.dataBodyRecognition[0] > -1 || analyseResult.dataBodyRecognition[1] > -1) &&
              <>
                <ComponentWithPop text={t('show body borders')}>
                  <div
                    onClick={() => handleShowBorders(!bodyBorderShow)}
                    className={`d-flex ${style.hidOnSmallScreen}`}>
                    <ViewDay style={{
                      marginRight: '5px',
                      cursor: 'pointer',
                      width: 25,
                      fill: bodyBorderShow ? 'black' : 'lightgray'
                    }}/>
                  </div>
                </ComponentWithPop>
                <hr style={{ borderColor: borderColors.borderPrimary200 }}
                    className={`m-0 ${style.hr} ${style.hidOnSmallScreen}  mr-2`}/>
              </>
            }
            {enabledSections.indexOf('allowedlist') > -1 && allowedListsData?.length ?
              <>
                <ComponentWithPop text={t('add entry to my allowed list')}>
                  <div onClick={() => handleColBasinClick('add')}
                       tabIndex={config.tabIndexes.editorMenu}
                       data-menu-item="add"
                       className={`d-flex mr-2 ${style.withIcon} ${style.hidOnSmallScreen}`}>
                    <Add className={style.icon} style={{
                      backgroundColor: isContrast ? '' : bgColors.bgPlayBtn,
                      color: colors.colorContrast
                    }}/>
                    <Check style={{ fill: colors.colorIcons }}/>
                  </div>
                </ComponentWithPop>

                <hr style={{ borderColor: borderColors.borderPrimary200 }}
                    className={`m-0 ${style.hr} ${style.hidOnSmallScreen}  mr-2`}/>
              </> : null
            }
            {(textToneData?.length && enabledSections.indexOf('textbin') > -1) ? <>
                <ComponentWithPop text={t('throw into the bin')}>
                  <div className={`d-flex mr-2 ${style.withIcon} ${style.hidOnSmallScreen}`}
                       onClick={() => handleColBasinClick('bin')} data-menu-item="textbin"
                       tabIndex={config.tabIndexes.editorMenu + 1}>
                    <Remove className={style.icon} style={{
                      backgroundColor: isContrast ? '' : bgColors.bgDeleteBtn,
                      color: colors.colorPrimary0
                    }}/>
                    <Delete style={{ fill: colors.colorIcons }}/>
                  </div>
                </ComponentWithPop>
                <hr style={{ borderColor: borderColors.borderPrimary200 }}
                    className={`m-0 ${style.hr} ${style.hidOnSmallScreen} mr-2`}/>
              </>
              :
              null}
            {(enabledSections.indexOf('magic_wand') > -1 && magicWandEnable) ?
              <>
                <ComponentWithPop text={t('analyse_magic_wand-tooltip')}>
                  <div onClick={handleMagicWandClick}
                       tabIndex={config.tabIndexes.editorMenu + 2}
                       data-menu-item="magic-wand"
                       className={`d-flex mr-2 ${style.withIcon} ${style.hidOnSmallScreen}`}>
                    <img src={magicWantIcon} alt="ai-magic"/>
                  </div>
                </ComponentWithPop>

                <hr style={{ borderColor: borderColors.borderPrimary200 }}
                    className={`m-0 ${style.hr} ${style.hidOnSmallScreen}  mr-2`}/>
              </> : null
            }
            <ComponentWithPop text={t('download text')}>
              <div onClick={() => setShowDownloadMenu(s => !s)} className={`d-flex ${style.hidOnSmallScreen}`}
                   data-menu-item="download-text" tabIndex={config.tabIndexes.editorMenu + 3}>
                <img src={folderIcon} alt=""/>
              </div>
            </ComponentWithPop>
            <Collapse className={style.downloadMenu} in={showDownloadMenu}
                      style={{ backgroundColor: bgColors.bgPrimary0, zIndex: 1000, color: colors.colorText }}>
              <ul onMouseLeave={() => setShowDownloadMenu(false)} className={style.downloadMenuUl}>
                <li tabIndex={showDownloadMenu ? config.tabIndexes.editorMenu + 4 : -1} key="docx"
                    title={t('docx-title')} onClick={() => {
                  setShowDownloadMenu(false)
                  handleDownloadAsFile('docx')
                }} data-menu-item="item"><img src={docxIcon} alt=""/> {t('docx-file')}</li>
                <li tabIndex={showDownloadMenu ? config.tabIndexes.editorMenu + 5 : -1} key="txt" title={t('txt-title')}
                    onClick={() => {
                      setShowDownloadMenu(false)
                      handleDownloadAsFile('txt')
                    }} data-menu-item="item"><img src={txtIcon} alt=""/> {t('txt-file')}</li>
                <li tabIndex={showDownloadMenu ? config.tabIndexes.editorMenu + 6 : -1} key="html"
                    title={t('html-title')} onClick={() => {
                  setShowDownloadMenu(false)
                  handleDownloadAsFile('html')
                }} data-menu-item="item"><img src={htmlIcon} alt=""/> {t('html-file')}</li>
                <li tabIndex={showDownloadMenu ? config.tabIndexes.editorMenu + 7 : -1} key="doc" title={t('doc-title')}
                    onClick={() => {
                      setShowDownloadMenu(false)
                      handleDownloadAsFile('doc')
                    }} data-menu-item="item"><img src={docIcon} alt=""/> {t('doc-file')}</li>
              </ul>
            </Collapse>
            {/* <hr style={{borderColor: borderColors.borderPrimary200}}
                        className={`m-0 ${style.hr} ${style.hidOnSmallScreen} mr-2 ml-2`}/>
                    <ComponentWithPop text={t("save analysis")}>
                        <div onClick={() => setModalOpenType('WordSaveModal')} className={`d-flex ${style.hidOnSmallScreen}`}>
                            <Save style={{cursor: "pointer", width: 25, fill: colors.colorPrimary200}}/>
                        </div>
                    </ComponentWithPop> */}
            {!!enabledTemplate['export_template_single'] && <>
              <hr style={{ borderColor: borderColors.borderPrimary200 }}
                  className={`m-0 ${style.hr} ${style.hidOnSmallScreen} mr-2 ml-2`}/>
              <ComponentWithPop text={t('Export issue details')}>
                <div onClick={() => {
                  setModalOpenType('exportIssueDetails')
                  setModalState(true)
                }}
                     className={`d-flex ${style.hidOnSmallScreen}`}>

                  <AssignmentIcon style={{ cursor: 'pointer', width: 25, fill: 'green' }}/>

                </div>
              </ComponentWithPop>
              {/* <hr style={{borderColor: borderColors.borderPrimary200}}
                        className={`m-0 ${style.hr} ${style.hidOnSmallScreen} mr-2 ml-2`}/></> :
                        <div/> */}
            </>
            }
            {enabledSections.indexOf('archive') > -1 &&
              <>
                {(saveArchive?.id && !isObjectEmpty(analyseResult)) ? <>
                  <hr style={{ borderColor: borderColors.borderPrimary200 }}
                      className={`m-0 ${style.hr} ${style.hidOnSmallScreen} mr-2 ml-2`}/>
                  <ComponentWithPop text={t('Save As New Version')}>
                    <div onClick={e => {
                      e.preventDefault()
                      if (saveArchive?.id && !isObjectEmpty(analyseResult)) {
                        setModalOpenType('WordSaveAsNewVersion')
                        setModalState(true)
                      }
                    }} tabIndex={config.tabIndexes.editorMenu + 8}
                         data-menu-item="save-archive-version"
                         className={`d-flex mr-2 ${style.withIcon} ${style.hidOnSmallScreen}`}>


                      {isContrast && <DataUsage className={style.icon} style={{ color: colors.colorContrast }}/>}
                      {/* colors.colorPrimary200 */}
                      <SaveIcon style={{
                        cursor: 'pointer',
                        width: 25,
                        fill: isContrast ? colors.colorPrimary0 : colors.colorPink
                      }}/>
                    </div>
                  </ComponentWithPop> </> : <></>}
                <hr style={{ borderColor: borderColors.borderPrimary200 }}
                    className={`m-0 ${style.hr} ${style.hidOnSmallScreen} mr-2 ml-2`}/>
                <ComponentWithPop text={t('Save As New Analysis')}>
                  <div onClick={() => {
                    setModalOpenType('WordSaveInArchive')
                    setModalState(true)
                  }} tabIndex={config.tabIndexes.editorMenu + 9} data-menu-item="save-archive"
                       className={`d-flex ${style.hidOnSmallScreen}`}>
                    <SaveIcon style={{
                      cursor: 'pointer',
                      width: 25,
                      fill: !isContrast ? ((!isObjectEmpty(analyseResult)) ? colors.colorPurple : colors.colorPink) : colors.colorPrimary0
                    }}/>
                  </div>
                </ComponentWithPop>
              </>
            }
            {/* Old text import button commented part 1/2
                    <ComponentWithPop text={t("Word-upload")}>
                        <Dropzone onDrop={handleUploadFile}>
                            {({getRootProps, getInputProps}) => (
                                <div  className={`${style.hidOnSmallScreen} d-flex`}  {...getRootProps()}>
                                        <img src={wordIcon} alt=""/>
                                    <input accept=".txt,.docx,.pdf" id='uploadFile' {...getInputProps()} />
                                </div>
                            )}
                        </Dropzone>
                    </ComponentWithPop>*/}
            <hr style={{ borderColor: borderColors.borderPrimary200 }}
                className={`m-0 ${style.hr} ${style.hidOnSmallScreen} mr-2 ml-2`}/>
            {/* <ComponentWithPop text={t("batchProcessingButtonUpload")}>
                            <Dropzone onDrop={handleBatchProcessingUpload}>
                                {({ getRootProps, getInputProps }) => (
                                    <div className={`${style.hidOnSmallScreen} d-flex`}  {...getRootProps()}> */}
            {/* <img src={wordIcon} alt=""/> */}
            {/*
                                        <InsertDriveFileIcon style={{ cursor: "pointer", width: 25, fill: colors.colorPrimary200 }} />

                                        <input accept=".txt,.docx,.pdf" id='batchProcessingUploadFile' {...getInputProps()} />
                                    </div>
                                )}
                            </Dropzone>
                        </ComponentWithPop> */}
            <ComponentWithPop text={`${t('start-new-analysis')}`}>
              <div tabIndex={config.tabIndexes.editorMenu + 10} data-menu-item="new-analysis"
                   onClick={handleRestartAll}>
                <button
                  accessKey={accessKeys.startNewAnalyse}
                  aria-label={t('start-new-analysis')}
                  onClick={handleRestartAll}
                  style={{ backgroundColor: bgColors.bgPrimary300, color: colors.colorPrimary0 }}
                  className={`d-flex ${style.neu}`}>
                  <Add/>
                </button>
              </div>
            </ComponentWithPop>
            <hr style={{ borderLeft: `1px solid ${borderColors.borderPrimary200}`, height: '100%' }}
                className={`m-0 mr-2 ml-2`}/>
            {enabledSections.indexOf('dashboard') > -1 &&
              <NavLink to={'/dashboard/single'} accessKey={accessKeys.singleDashboard} aria-label={t('go-to-the-Statistics')} tabIndex={config.tabIndexes.editorMenu + 11}>
                <ComponentWithPop text={`${t('go-to-the-Statistics')}`}>
                  <button
                    aria-label={`${t('go-to-the-Statistics')}`}
                    style={{
                      color: colors.colorPrimary0,
                      backgroundColor: theme === config.THEMES_MODES.CONTRAST_LIGHT ? bgColors.bgPrimary300 : bgColors.bgBlue1000,
                      padding: 1
                    }}
                    className={`d-flex ${style.neu}`}>
                    <Equalizer style={{ width: '21px' }}/>
                  </button>
                </ComponentWithPop>
              </NavLink>
            }
            <hr style={{ borderLeft: `1px solid ${borderColors.borderPrimary200}`, height: '100%' }}
                className={`m-0 mr-2 ml-2`}/>
            {enabledSections.indexOf('double-interface') > -1 && (
              <NavLink
                accessKey={accessKeys.ainstein}
                tabIndex={aiButtonEnable ? config.tabIndexes.editorMenu + 12 : -1}
                to={'/ainstein'}
                style={{ textDecoration: 'none', cursor: aiButtonEnable ? 'pointer' : 'not-allowed' }}
                aria-disabled={!aiButtonEnable}
                onClick={handleAiNavClick}
              >
                <ComponentWithPop text={aiButtonEnable ? `${t('switch to ai mode')}` : `${t('ai_text_too_long')}`}>
                  <Button
                    disabled={!aiButtonEnable}
                    variant="contained"
                    className={`${style.actualBtn} ml-2 `}
                    aria-label={t('switch to ai mode')}
                    style={{
                      cursor: aiButtonEnable ? 'pointer' : 'not-allowed',
                      color: aiButtonEnable ? colors.colorPrimary0 : colors.colorPrimary400,
                      backgroundColor: aiButtonEnable ? bgColors.bgBlue1000 : bgColors.bgPrimary200
                    }}
                  >
                    <img
                      src={aiButtonEnable ? theme === config.THEMES_MODES.CONTRAST_LIGHT ? ComBotBlackNoHorn : ComBotWhiteNoHorn : ComBotGreyNoHorn}
                      alt="ComLab AI Bot" width="27" style={{ marginTop: -4 }}/>
                    <p>{t('text bot button')}</p>
                  </Button>
                </ComponentWithPop>
              </NavLink>
            )}

          </>
        }
        {(resultTemplate === 0) &&
          <>
            {/* Old text import button commented part 2/2
                           <Dropzone onDrop={handleUploadFile}>
                            {({getRootProps, getInputProps}) => (
                                <div  {...getRootProps()}>
                                    <label onClick={e => e.stopPropagation()} htmlFor="uploadFile"
                                           style={{backgroundColor: bgColors.bgBlue1000}}
                                           className={`pl-2 pr-2 p-1 ${style.actualBtn}`}>
                                        <img className={`mr-2`} src={wordUploadIcon} alt=""/>
                                        <p>{t("Word-upload")}</p>
                                    </label>
                                    <input accept=".txt,.docx,.pdf" id='uploadFile' {...getInputProps()} />
                                </div>
                            )}
                        </Dropzone>*/}
            {enabledSections.indexOf('rv-processing') > -1 && customOptions['ruv_button'] !== undefined ?
              <>
                {(showLoadText) ?
                  <div style={{
                    height: '5px',
                    display: 'flex',
                    paddingLeft: '3px',
                    marginTop: '-25px',
                    paddingRight: '3px'
                  }}>
                    <h6 style={{ fontSize: '10px', marginTop: '10px' }}>{t('nect tot the FOR button')}</h6>
                    <span style={{ fontSize: '8px', marginLeft: '20px' }}>
                                            <Box sx={{ display: 'flex' }}>
                                                <CircularProgress
                                                  size="2rem"
                                                />
                                            </Box>
                                        </span>
                  </div>
                  :
                  !showUploadBar && <ComponentWithPop text={`${t('rv-processing')}`}>
                    <Dropzone multiple={false} onDrop={(e) => {
                      setShowLoadText(true)
                      checkKeys(e)
                    }
                    }>
                      {({ getRootProps, getInputProps }) => (
                        <div  {...getRootProps()}>
                          <label onClick={e => e.stopPropagation()} htmlFor="batchRVUpload"
                                 style={{ backgroundColor: bgColors.bgYellow1000 }}
                                 className={`pl-2 pr-2 p-1 ml-2 ${style.actualBtn} ${style.autoWidth}`}>
                            <InsertDriveFileIcon
                              style={{ cursor: 'pointer', width: 25, fill: 'white', marginBottom: '2px' }}/>
                            <p>{t('rv-process-button')}</p>
                          </label>
                          <input accept=".csv" id="batchRVUpload" {...getInputProps()} />
                        </div>
                      )}
                    </Dropzone>
                  </ComponentWithPop>}
                {showUploadBar &&
                  <div style={{
                    height: '5px',
                    display: 'flex',
                    paddingLeft: '3px',
                    marginTop: '-25px',
                    paddingRight: '3px'
                  }}>
                    <h6 style={{ fontSize: '10px', marginTop: '10px' }}>{t('analysisInProgress')}</h6>
                    <ComponentWithPop text={`${t('Stop the analyse pop')}`}>
                      <Button
                        onClick={handleStopRVAnalyse}
                        style={{ cursor: 'pointer' }}
                        color="secondary"
                        variant="contained"
                        className={`${style.actualBtn} ml-2`}>
                        {t('Stop the analyse button')}
                      </Button>
                    </ComponentWithPop>
                    <span style={{ fontSize: '8px', marginLeft: '20px' }}> <CircularProgressWithLabel
                      value={uploadBarNow}/> </span>
                  </div>
                }
              </> : <></>
            }
            <ComponentWithPop text={`${t('Import-your-word')}`}>
              {/* If user have no right for archive, batch upload is disabled: */}
              <Dropzone onDrop={handleBatchProcessingUpload} multiple={!!enabledSections.includes('archive')}>
                {({ getRootProps, getInputProps }) => (
                  <div  {...getRootProps()} accessKey={accessKeys.openFile}
                        tabIndex={config.tabIndexes.editorMenu + 13}>
                    <label onClick={e => e.stopPropagation()} htmlFor="batchProcessingUploadFile"
                           style={{
                             backgroundColor: isContrast ? bgColors.bgPrimary200 : bgColors.bgBlue1000,
                             color: colors.colorPrimary0
                           }}
                           className={`pl-2 pr-2 p-1 ml-2 ${style.actualBtn} ${style.autoWidth}`}>
                      {/* <img className={`mr-2`} src={wordUploadIcon} alt=""/> */}
                      <InsertDriveFileIcon
                        style={{ cursor: 'pointer', width: 25, fill: colors.colorPrimary0, marginBottom: '2px' }}/>
                      <p>{t('batchProcessingButtonUpload')}</p>
                    </label>
                    <input accept=".txt,.docx,.pdf" id="batchProcessingUploadFile" {...getInputProps()} />
                  </div>
                )}
              </Dropzone>
            </ComponentWithPop>
          </>
        }
        <ComponentWithPop text={`${t('Reload-the-analysis')}`}>
          <Button
            onClick={() => {
              if (mustReload) {
                setMustReload(false)
                handleOnAnalyseClick()
              }
            }}
            style={{
              cursor: 'pointer', color: mustReload ? colors.colorPrimary0 : colors.colorMutedText,
              backgroundColor: mustReload ? bgColors.bgBlue1000 : bgColors.bgPrimary200
            }}
            variant="contained"
            disabled={!(mustReload)}
            accessKey={accessKeys.reloadAnalyse}
            tabIndex={config.tabIndexes.editorMenu + 14}
            className={`${style.actualBtn} ml-2`}>
            <Replay style={{ width: '21px', color: mustReload ? colors.colorPrimary0 : colors.colorMutedText }}/>
            <p>{t('Update button')}</p>
          </Button>
        </ComponentWithPop>
      </div>
    </div>
  )
}

export default HeadPart
